import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';

const SignInLayer = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignIn = async (e) => {
    e.preventDefault();
    setError(''); // Clear any previous errors
    setLoading(true);
    try {
      const response = await api.post('auth/login', { email, password });
      if (response.data.status) {
        // Save user and token in localStorage if valid
        const user = response.data.response.user;
        // Check if user type is broker; if so, show error and exit.
        if (user.type === 'broker') {
          toast.error('Broker cannot sign into dashboard');
          return;
        }
        const access_token = response.data.response.access_token;
        const refresh_token = response.data.response.refresh_token;
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('access_token', access_token);
        localStorage.setItem('refresh_token', refresh_token);

        // Navigate to dashboard or desired page
        navigate('/');
      } else {
        console.error('Login failed:', response.data.message);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 403) {
          setError('Email is not verified. Please check your email.');
        } else if (error.response.status === 400) {
          setError('Invalid credentials. Please try again.');
        } else if (error.response.status === 402) {
          setError('Account is not approved yet, please wait for your approval.');
        } else {
          setError('An unexpected error occurred. Please try again later.');
        }
      } else {
        setError('Network error. Please check your connection.');
      }
    }
    setLoading(false);
  };

  return (
    <section className="auth bg-base d-flex flex-wrap">
      <div className="auth-left d-lg-block d-none">
        <div className="d-flex align-items-center flex-column h-100 justify-content-center">
          <img
            src="assets/images/auth/1.jpg"
            alt=""
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>
      </div>
      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100">
          <Link to="/" className="mb-40 max-w-290-px">
            {/* <img src="assets/images/logo.png" alt="" /> */}
            <h3>Brokerz</h3>
          </Link>
          <h6 className="mb-12">Sign In to your Account</h6>
          <p className="mb-32 text-secondary-light text-m">
            Welcome back! Please enter your details
          </p>
          {error && <div className="text-danger mb-16">{error}</div>}
          <form onSubmit={handleSignIn}>
            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="mage:email" />
              </span>
              <input
                type="email"
                className="form-control h-56-px bg-neutral-50 radius-12"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="position-relative mb-20">
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  id="your-password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <span
                className="eye-icon position-absolute end-0 top-50 translate-middle-y me-3 cursor-pointer"
                onClick={() => setShowPassword(!showPassword)}
              >
                <Icon icon={showPassword ? 'mdi:eye-off' : 'mdi:eye'} />
              </span>
            </div>
            <div className="d-flex justify-content-end gap-2">
              <Link to="/forgot-password" className="text-primary-600 fw-medium">
                Forgot Password?
              </Link>
            </div>
            <button
              type="submit"
              className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
              disabled={loading}
            >
              {loading ? <Spinner animation="border" size="sm" /> : 'Sign In'}
            </button>
            <button
              type="button"
              className="btn btn-outline-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-16 d-flex align-items-center justify-content-center gap-2"
              onClick={() => {
                navigator.clipboard.writeText('support@thebrokerz.com');
                toast.success('Email copied to clipboard!');
              }}
            >
              <Icon icon="mdi:email-outline" />
              support@thebrokerz.com
            </button>
            <div className="mt-32 text-center text-sm">
              <p className="mb-0">
                Don't have an account?{" "}
                <Link to="/sign-up" className="text-primary-600 fw-semibold">
                  Sign Up
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SignInLayer;
